module.exports = __webpack_public_path__ + "img/min.33ed41e1.png";